// extracted by mini-css-extract-plugin
module.exports = {"container":"Desktop_container__2o_NL"};